// src/components/footer/FooterSocialCTA.jsx
import React from 'react';
import SocialMediaPin from '../socialMedia/SocialMediaPin';
import { FETLIFE_URL, THRONE_NANNYM_URL } from '../../utils/Constants';
import { GiStoneThrone } from 'react-icons/gi';
import FetlifeIcon from '../../assets/images/icons/fetfile-icon-no-background-white.svg';

function FooterSocialCTA() {
  const navigateToSocialMedia = (url) => {
    window.open(url, '_blank', 'noopener,noreferrer');
  };

  const socialMediaLinks = [
    {
      serviceName: 'Throne',
      icon: <GiStoneThrone size={24} />,
      url: THRONE_NANNYM_URL,
      ariaLabel: 'Open Throne in a new tab',
      title: 'Throne',
    },
    {
      serviceName: 'Fetlife',
      url: FETLIFE_URL,
      icon: <img src={FetlifeIcon} alt="Fetlife" className="w-6 h-6" />,
      ariaLabel: 'Open Fetlife profile in a new tab',
      title: 'Fetlife',
    },
  ];

  return (
    <section className="grid justify-center">
      <div className="grid grid-flow-col w-fit gap-1">
        {socialMediaLinks.map((social) => (
          <SocialMediaPin
            key={social.serviceName}
            serviceName={social.serviceName}
            icon={social.icon}
            url={social.url}
            ariaLabel={social.ariaLabel}
            title={social.title}
          />
        ))}
      </div>
    </section>
  );
}

export default FooterSocialCTA;
